import React from 'react';
import PropTypes from 'prop-types';
import { asDialog } from '../Common/Decorators';
import { CourseDialogs } from '../../constants/Dialogs';
import DialogActions from '../../actions/DialogActionCreator';
import { Dialog, FlatButton, Checkbox } from 'material-ui';
import CourseActions from '../../actions/CourseActionCreator';

const anyModulesSelected = (modules) => !!modules && Object.keys(modules).reduce((a, k) => (a || modules[k]), false);
const onRetake = ({courseId, enrolmentId, modules}) => {
    const resetModules = Object.keys(modules).filter(k => !!modules[k]);
    return CourseActions.resetEnrolment(courseId, enrolmentId, {resetModules});
};

const RetakeCourseDialog = ({open, draft = {modules: {}}, modules, courseId, enrolmentId}) => {
    if (!modules || modules.length === 0 || !draft.courseId || !draft.enrolmentId) {
        DialogActions.close();
        return null;
    }

    return (
        <Dialog
            className="cent-dialog"
            title="Retake course"
            open={open === CourseDialogs.RETAKE_COURSE}
            onRequestClose={() => DialogActions.close()}
            actions={[
                <FlatButton key="btn-cancel" label="Cancel" onTouchTap={() => DialogActions.close()} />,
                <FlatButton
                    key="btn-switch"
                    label="Retake"
                    primary={true}
                    disabled={!anyModulesSelected(draft.modules)}
                    onTouchTap={() => onRetake(draft).then(() => DialogActions.close()) }
                />
            ]}
        >
            <div>Please select which modules you want to retake</div>
            <ul className="cent-radio-button-group">
                {modules
                    .filter(m => !!m && m.type === 'e-learning')
                    .map(m => (
                    <li key={m.id} className="">
                        <Checkbox
                            label={<span><strong>{m.name}</strong> <em>{m.type}</em></span>}
                            labelPosition="right"
                            checked={!!draft.modules[m.id]}
                            onCheck={(e, value) => DialogActions.updateDraft('modules', {...draft.modules, [m.id]: value})}
                        />
                    </li>
                ))}
            </ul>
        </Dialog>
    );
};

RetakeCourseDialog.propTypes = {
    modules: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            type: PropTypes.string,
        })
    )
};

export default asDialog(RetakeCourseDialog, CourseDialogs.RETAKE_COURSE);
